import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Url from '../../../apiBaseUrl/APIConfig';
import { headers } from '../../../components/Utility';
import { PatientDataDetailsRes } from './Model';

// State structure maintained from ActionTypes.ts
export interface AddPatientPointDataState {
  getPatientDataDetailsRes: PatientDataDetailsRes;
  loading: boolean;
  pageCount: number;
}

const initialState: AddPatientPointDataState = {
  loading: false,
  getPatientDataDetailsRes: {} as PatientDataDetailsRes,
  pageCount: 0,
};

/**
 * Async Thunk replacing the logic in API.ts
 */
export const getPatientDataDetailsList = createAsyncThunk(
  'patientData/getDetailsList',
  async ({ patientid, pageNo }: { patientid: string; pageNo: any }, { rejectWithValue }) => {
    try {
      // Endpoint and Payload logic preserved from API.ts
      const response = await axios.post(
        `${Url.imageUploadUrl}/adminapp/api/patientDetails/get_patientDetailsList_from_dashboard?page=${Number(pageNo)}&size=50`,
        { patientId: patientid },
        { headers }
      );

      // Returning exactly what the original Actions expected
      return {
        resData: response.data,
        pageCount: response.data.numberOfPages,
      };
    } catch (error: any) {
      console.log('error record====', error);
      return rejectWithValue(error.message);
    }
  }
);

const patientDataPointListByPatientIDSlice = createSlice({
  name: 'patientData',
  initialState,
  reducers: {
    // Keeping a placeholder for manual updates if needed
    resetPatientData: (state) => {
      state.getPatientDataDetailsRes = {} as PatientDataDetailsRes;
      state.pageCount = 0;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      // Replaces PATIENT_DATA_DETAILS_POINT_LOADING
      .addCase(getPatientDataDetailsList.pending, (state) => {
        state.loading = true;
        state.getPatientDataDetailsRes = {} as PatientDataDetailsRes;
      })
      // Replaces PATIENT_DATA_DETAILS_POINT_SUCCESS & GET_LIST
      .addCase(getPatientDataDetailsList.fulfilled, (state, action) => {
        state.loading = false;
        state.getPatientDataDetailsRes = action.payload.resData; // Original payload structure
        state.pageCount = action.payload.pageCount;             // Original pageCount logic
      })
      // Replaces PATIENT_DATA_DETAILS_POINT_FAIL
      .addCase(getPatientDataDetailsList.rejected, (state) => {
        state.loading = false;
        state.getPatientDataDetailsRes = {} as PatientDataDetailsRes;
      });
  },
});

export const { resetPatientData } = patientDataPointListByPatientIDSlice.actions;
export default patientDataPointListByPatientIDSlice.reducer;